<template>
  <p>{{tips}}</p>
</template>
<script>
import { getValueByPath } from './index'
import defaultTips from './tips'
export default {
  name: 'Vdtips',
  props: {
    path: {
      require: true
    }
  },
  computed: {
    tips() {
      const { path } = this
      // 递归向上查找存在validators或$options.validators的父级
      let parent = this.$parent
      while (
        parent !== this.$root &&
        !parent.validators &&
        !parent.$options.validators
      ) {
        parent = parent.$parent
      }
      const $v = parent.$v || {}
      const validators = parent.validators || parent.$options.validators || {}
      const path$v = getValueByPath($v, path)
      const pathValidator = getValueByPath(validators, path)
      const flattenParams = path$v.$flattenParams()
      for (const v of flattenParams) {
        const paramsType = v.params.type
        if (!path$v[paramsType]) {
          let customTips
          if (validators) {
            const validatorItem = pathValidator[v.name]
            if (typeof validatorItem === 'object') {
              customTips = validatorItem.tips
            } else {
              customTips = validatorItem
            }
            if (typeof customTips === 'function') {
              customTips = customTips(v.params)
            }
          }
          let defaultTip = defaultTips[paramsType]
          if (typeof defaultTip === 'function') {
            defaultTip = defaultTip(v.params)
          }
          return (
            customTips ||
            defaultTip ||
            `未定义${paramsType}的默认提示, 字段为${path.join('.')}`
          )
        }
      }
      return ''
    }
  }
}
</script>
